const Labels = {
  remove: "删除",
  create: "创建",
  edit: "编辑",
  config: "配置",
  detail: "详情",
  refresh: "刷新",
};

const Icons = {
  remove: "el-icon-delete",
  create: "el-icon-plus",
  edit: "el-icon-edit-outline",
  config: "el-icon-setting",
};

export default {
  getText: (sName) => {
    if (!sName) {
      return "";
    }
    return Labels[sName] || sName;
  },
  getRealValue: (value, ...params) => {
    if (typeof value === "function") {
      return value(...params);
    }

    return value;
  },
  getIcon: (sName) => {
    if (!sName) {
      return "";
    }
    return Icons[sName];
  },
};

/**
 * 单元格默认展示，涉及type:enum,text,date
 */
export const EMPT_TEXT = "- -";
